var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRoleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0668 16.3999C24.0292 16.3999 19.1338 21.2953 19.1338 27.333C19.1338 33.3706 24.0292 38.266 30.0668 38.266C36.1045 38.266 40.9999 33.3714 40.9999 27.333C40.9999 21.2945 36.1045 16.3999 30.0668 16.3999Z",
    fill: "#403C6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0002 43.7329H19.1333C13.0956 43.7329 8.2002 48.6291 8.2002 54.6668V65.5998H51.9333V60.9931C45.4823 57.9148 41.0002 51.3458 41.0002 43.7329Z",
    fill: "#403C6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1329 30.0669C52.5848 30.0669 46.4668 36.1849 46.4668 43.7338C46.4668 51.2819 52.5848 57.4 60.1329 57.4C67.6818 57.4 73.7999 51.2819 73.7999 43.733C73.7999 36.1841 67.6818 30.0669 60.1329 30.0669ZM67.3834 48.0815L64.4847 50.9802L60.1329 46.6317L55.7877 50.9802L52.8833 48.0815L57.2342 43.733L52.8833 39.3854L55.7877 36.4867L60.1329 40.8351L64.4847 36.4867L67.3834 39.3854L63.0316 43.733L67.3834 48.0815Z",
    fill: "#403C6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRoleIcon);
export default __webpack_public_path__ + "static/media/no-role-icon.5c9e2b738b93cd66867b4ec482d0d8f6.svg";
export { ForwardRef as ReactComponent };